/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * File field representation.
 */
export interface ClaimsSchemaFieldFileValue {
    /** Determine whether the field values should be an array. */
    isArray?: boolean;
    /** Field name. */
    name: string;
    notEmpty?: boolean;
    /** The human-readable name of the field can be used to display the field in the UI. */
    title?: string;
}
